module.exports = __webpack_public_path__ + "static/media/austin-mayer.fb8874e9.jpeg";